// jwtErrorHandler.js
export const handleJWTResponse = async (response, setJwtErrorMessage, setShowJWTError) => {
    if (response.status === 401) {
        const errData = await response.json();
        if (['TOKEN_EXPIRED', 'NO_TOKEN', 'INVALID_TOKEN'].includes(errData.code)) {
            setJwtErrorMessage(errData.message);
            setShowJWTError(true);
            throw new Error("JWT error handled");
        }
        throw new Error(errData.message || "Authentication failed");
    }
    
    if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
    }
    
    return response.json();
};